<template>
  <v-card class="dashboard-kpi flex-grow-1 ma-0" :class="{ 'dashboard-kpi--destaque': destaque }" outlined>
    <span class="dashboard-kpi__titulo">{{ titulo }}</span>

    <div v-if="carregando" class="align-center d-flex dashboard-estado justify-center">
      <v-progress-circular color="primary" indeterminate size="22" />
    </div>

    <div v-else-if="erro" class="dashboard-estado dashboard-estado--erro">Não foi possível carregar este indicador.</div>

    <template v-else-if="dados">
      <strong class="dashboard-kpi__valor">{{ dados.valor | inteiro }}</strong>

      <div v-if="dados.faixas" class="dashboard-kpi__faixas">
        <div v-for="faixa in dados.faixas" :key="faixa.chave" class="dashboard-kpi__faixa">
          <span :class="{ 'dashboard-kpi__faixa--alerta': faixa.chave === 'vencidas' }">{{ faixa.rotulo }}</span>
          <strong :class="{ 'dashboard-kpi__faixa--alerta': faixa.chave === 'vencidas' }">{{ faixa.valor | inteiro }}</strong>
        </div>
      </div>
    </template>
  </v-card>
</template>

<script>
  export default {
    name: 'CardKpiDashboard',

    filters: {
      inteiro(valor) {
        return new Intl.NumberFormat('pt-BR').format(Number(valor) || 0);
      }
    },

    props: {
      titulo: { type: String, required: true },
      dados: { type: Object, default: null },
      carregando: { type: Boolean, default: false },
      erro: { type: Boolean, default: false },
      destaque: { type: Boolean, default: false }
    }
  };
</script>

<style scoped>
  .dashboard-kpi {
    border-color: #e2e6eb !important;
    border-radius: 10px !important;
    box-shadow: none !important;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 18px 20px !important;
  }

  .dashboard-kpi__titulo {
    color: #4f5a67;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.35;
  }

  .dashboard-kpi--destaque .dashboard-kpi__titulo {
    color: #17202a;
    font-size: 15px;
    font-weight: 600;
  }

  .dashboard-kpi__valor {
    color: #17202a;
    font-size: 36px;
    font-variant-numeric: tabular-nums;
    font-weight: 600;
    line-height: 1;
  }

  .dashboard-kpi--destaque .dashboard-kpi__valor {
    font-size: 44px;
  }

  .dashboard-kpi__faixas {
    display: flex;
    flex-direction: column;
    font-size: 13px;
    gap: 8px;
  }

  .dashboard-kpi__faixa {
    border-top: 1px solid #eef1f5;
    color: #4f5a67;
    display: flex;
    justify-content: space-between;
    padding-top: 8px;
  }

  .dashboard-kpi__faixa strong {
    color: #17202a;
    font-variant-numeric: tabular-nums;
    font-weight: 600;
  }

  .dashboard-kpi__faixa--alerta,
  .dashboard-kpi__faixa--alerta strong {
    color: #b4501a;
    font-weight: 600;
  }

  .dashboard-estado {
    color: #4f5a67;
    font-size: 12px;
    min-height: 64px;
  }

  .dashboard-estado--erro {
    color: #d14343;
  }
</style>
